import React, { useEffect, useState } from 'react';
import { CsvRegisterProp, RelatorioProps } from 'models/campanhas';
import { CampaignPopoverTableProps } from 'models/campaign-mkt';
import { ListItem, Tooltip } from '@material-ui/core';
import { UseCampanhaTableContext } from 'context/campanha-context';
import { ValueSendedModal } from '@fundacao/shared-components/esm/ie';
import ButtonPopover from 'components/ButtonPopover/button-popover';
import campanhaService from 'services/campanha-service/campanha-service';
import fileDownload from 'js-file-download';
import IconTooltip from 'assets/img/alert-tooltip.svg';
import { getCampaignFileNameBase } from 'utils/campanha-utils';
import * as S from './style';

function PopoverTable({
  openPopover,
  value,
  setOpenPopover,
  'aria-label': ariaLabel = 'Abrir ações da campanha',
}: CampaignPopoverTableProps): JSX.Element {
  const {
    anchorEl,
    open,
    setOpen,
    setSelected,
    setAnchorEl,
  } = UseCampanhaTableContext();

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [modalInformation, setModalInformation] = useState<CsvRegisterProp[]>(
    [],
  );
  const [relatorioSelected, setRelatorioSelected] = useState<RelatorioProps>();

  const id = openPopover ? 'simple-popover' : undefined;

  const isValidIdRelatorio = value['id-relatório'];

  const handleClose = () => {
    setAnchorEl(null);
    setOpenPopover(false);
  };

  const handleDelete = () => {
    setSelected(value);
    setOpen(!open);
    handleClose();
  };

  const downloadDocument = async () => {
    if (!relatorioSelected) return;

    const campaignFileName = getCampaignFileNameBase(value['nome-campanha']);

    await Promise.all(
      relatorioSelected.arquivos.map(async (item) => {
        const nameDocument =
          item['tipo-arquivo'] === 'PDF'
            ? `${campaignFileName}-Resultado_do_envio_da_campanha`
            : `${campaignFileName}-planilha_para_correcao`;

        const document = await campanhaService.getArquivosRelatorio(
          item['id-arquivo'],
        );
        fileDownload(
          document,
          `${nameDocument}.${item['tipo-arquivo'].toLocaleLowerCase()}`,
        );
      }),
    );
  };

  const handleRelatorio = async () => {
    try {
      const response = await campanhaService.getRelatorioCampanha(
        value['id-relatório'],
      );
      setRelatorioSelected(response);
      setModalInformation([
        {
          text: 'Linhas enviadas',
          total: response.linhasSucesso,
        },
        {
          text: 'Linhas com erro',
          total: response.linhasErro,
        },
        {
          text: 'TOTAL',
          total: response.totalLinhas,
        },
      ]);
      setOpenModal(true);
    } catch (err) {
      const error: any = err;
      console.log(error);
    } finally {
      handleClose();
    }
  };

  useEffect(() => {
    if (openPopover) {
      document.body.id = 'open-popover';
    } else {
      document.body.id = '';
    }
  }, [openPopover]);

  return (
    <div>
      <ButtonPopover ariaLabel={ariaLabel} setOpenPopover={setOpenPopover} />
      {openModal ? (
        <ValueSendedModal
          isOpen={openModal}
          onClick={() => downloadDocument()}
          onClose={() => setOpenModal(false)}
          title="Resultado do envio da campanha"
          warningMessage="*Essas linhas não foram enviadas. Baixe os arquivos para fazer as correções indicadas no relatório e reenvie o arquivo CSV criando uma nova campanha."
          returnImport={modalInformation}
        />
      ) : (
        <S.PopoverStyled
          id={id}
          open={openPopover}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <S.ArrowPopover />
          <S.ContainerList padding={!isValidIdRelatorio}>
            <S.ListStyled>
              <ListItem onClick={handleDelete}>
                <S.Text>Excluir</S.Text>
              </ListItem>
              <ListItem
                onClick={isValidIdRelatorio && handleRelatorio}
                disabled={!isValidIdRelatorio}
              >
                <S.Text>Resultado do envio</S.Text>
                {!isValidIdRelatorio && (
                  <Tooltip
                    placement="top"
                    arrow
                    title="Funcionalidade implementada após o envio da campanha"
                  >
                    <S.Icon src={IconTooltip} alt="Atenção" />
                  </Tooltip>
                )}
              </ListItem>
            </S.ListStyled>
          </S.ContainerList>
        </S.PopoverStyled>
      )}
    </div>
  );
}

export default PopoverTable;
